let touchstartX = 0;
let touchendX = 0;
let touchstartY = 0;
let touchendY = 0;
let swipeVertical = false;

/**
 * @function
 * @description - Display/hide the remove item container, when sliding the sliding wrapper
 * @param {Event} event - Slide event
 */
const handleGesture = event => {
    const slideContainer = $(event.currentTarget);
    const $this = $(event.currentTarget);
    const $alternativeProducts = $this.find(".alternative-products-view:not(.d-none)");

    if ($alternativeProducts.length > 0) {
        return;
    }

    const removeItemContainer = $(event.currentTarget).siblings(".swipe-remove");
    const removeItem = $(event.currentTarget).siblings(".ct-cart-tile-remove");

    swipeVertical = Math.abs(touchstartY - touchendY) > Math.abs(touchstartX - touchendX);

    if (swipeVertical) { return; }
    if (touchendX < touchstartX) {
        removeItemContainer.removeClass("d-none");
        slideContainer.removeClass("swipe-effect-out").addClass("swipe-effect-in");
        removeItem?.removeClass("swipe-effect-out").addClass("swipe-effect-in");
    } else {
        removeItemContainer.addClass("d-none");
        slideContainer.removeClass("swipe-effect-in").addClass("swipe-effect-out");
        removeItem?.removeClass("swipe-effect-in").addClass("swipe-effect-out");

    }
};

/**
 * @function
 * @description - Initialize the slide effect
 */
const swipeTile = () => {
    const gestureZone = document.querySelectorAll(".ct-slide-container");

    gestureZone.forEach(element => {
        element.addEventListener("touchstart", event => {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        }, false);

        element.addEventListener("touchend", event => {
            if (!element.classList.contains("block-animation")) {
                touchendX = event.changedTouches[0].screenX;
                touchendY = event.changedTouches[0].screenY;
                handleGesture(event);
            }
        }, false);
    });
};

export { swipeTile };
